"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorBoundary = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var antd_1 = require("antd");
var Layout_1 = require("./Layout");
/**
 * https://reactjs.org/docs/error-boundaries.html
 */
var ErrorBoundary = /** @class */ (function (_super) {
    __extends(ErrorBoundary, _super);
    function ErrorBoundary() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {};
        return _this;
    }
    ErrorBoundary.getDerivedStateFromError = function (error) {
        return { error: error };
    };
    ErrorBoundary.prototype.render = function () {
        // If there's no error, just return what renders via the happy path.
        if (!this.state.error) {
            return this.props.children;
        }
        var showErrorDetails = process.env.NODE_ENV === 'development';
        var description = showErrorDetails ? (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("b", null,
                this.state.error.message,
                ":"),
            react_1.default.createElement(DebugInfo, null,
                react_1.default.createElement("pre", null, this.state.error.stack || JSON.stringify(this.state.error, null, 2))))) : (react_1.default.createElement(react_1.default.Fragment, null, this.props.defaultErrorMessage || 'Sorry, something went wrong. Please try again.'));
        return (react_1.default.createElement(Layout_1.Content, null,
            react_1.default.createElement(antd_1.Alert, { type: "error", message: "Error", description: description, showIcon: true })));
    };
    return ErrorBoundary;
}(react_1.default.PureComponent));
exports.ErrorBoundary = ErrorBoundary;
var DebugInfo = styled_components_1.default.code(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    ", "\n"], ["\n    ", "\n"])), function (_a) {
    var theme = _a.theme;
    return "\n        display: block;\n        padding: ".concat(theme.spacing.md.toString(), ";\n        margin: ").concat(theme.spacing.sm.toString(), " 0 0;\n        overflow: auto;\n        pre {\n            margin: 0;\n            padding: 0;\n            overflow: initial;\n        }\n    ");
});
var templateObject_1;
//# sourceMappingURL=ErrorBoundary.js.map